/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membersenabledtoast2Inputs */

const en_membersenabledtoast2 = /** @type {(inputs: Membersenabledtoast2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memberships are on`)
};

const de_membersenabledtoast2 = /** @type {(inputs: Membersenabledtoast2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitgliedschaft ist an`)
};

/**
* | output |
* | --- |
* | "Memberships are on" |
*
* @param {Membersenabledtoast2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const membersenabledtoast2 = /** @type {((inputs?: Membersenabledtoast2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membersenabledtoast2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_membersenabledtoast2(inputs)
	return de_membersenabledtoast2(inputs)
});
export { membersenabledtoast2 as "membersEnabledToast" }